import React from "react";
import { UserContext } from "../../UserContext";

const defaultInstagram = "https://www.instagram.com/clinicacreserferraz?igsh=aHE1dngxbXZ0cWhr&utm_source=qr";

const equipeMembros = [
    {
        nome: "Thaís Lopes",
        cargo: "Psicopedagoga",
        foto: "https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/psicologos%2Fnovas-fotos-2026%2FThai%CC%81s%20-%20Psicopedagoga.jpeg?alt=media&token=98df77a0-af64-438d-9399-3e977d7fae8e",
        instagram: "https://www.instagram.com/thais_psicopedagoga?stkn=MXEweGtkdmYzZmYwOA=="
    },
    {
        nome: "Gabriela Tomaz",
        cargo: "Pediatra",
        foto: "https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/site%2Fimagens%2Fequipe%2FGabrielaTomaz-pediatra.webp?alt=media&token=1eaa6319-b957-4666-9551-8a93f79b6acd",
        instagram: "https://www.instagram.com/gabrielapediatra?stkn=ZjE3cDZud2Q4d3Jj"
    },
    {
        nome: "Jessica Silvestre",
        cargo: "Psicóloga",
        foto: "https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/psicologos%2Fnovas-fotos-2026%2FJessica%20-%20psico%CC%81loga.jpeg?alt=media&token=a07eaec6-cc08-4033-ae65-925b432b0b10",
        instagram: defaultInstagram
    },
    {
        nome: "Maria Karolina",
        cargo: "Neuropsicóloga",
        foto: "https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/psicologos%2Fnovas-fotos-2026%2FMaria%20Karolina%20-%20Neuropsico%CC%81loga.jpeg?alt=media&token=b33101fe-90de-40cb-b809-b5c3edfdd42d",
        instagram: defaultInstagram
    },
    {
        nome: "Thaynara",
        cargo: "Psicóloga",
        foto: "https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/psicologos%2Fnovas-fotos-2026%2FThaynara%20-%20Psico%CC%81loga.jpeg?alt=media&token=be000333-943f-4839-9d09-dc331c7ea616",
        instagram: "https://www.instagram.com/psico.thaynara.reguero?stkn=M3hoNmdsN2Vvc2ti"
    },
    {
        nome: "Rafaela",
        cargo: "Psicóloga",
        foto: "https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/psicologos%2Fnovas-fotos-2026%2FRafaela%20-%20psico%CC%81loga.jpeg?alt=media&token=9194afd3-2a0c-47b4-8e20-e47d54f8058f",
        instagram: "https://www.instagram.com/psi.rafaelasales?stkn=eXJoNG5heHh5NGQ2"
    },
    {
        nome: "Lucimara",
        cargo: "Neuropsicopedagoga",
        foto: "https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/psicologos%2Fnovas-fotos-2026%2FLucimara%20-%20Neuropsicopedagoga.jpeg?alt=media&token=4fd87d0b-b559-4e8d-8a4a-b1a09c8c6c20",
        instagram: "https://www.instagram.com/neurolu?stkn=MTY1enRscDg3OGN0cw=="
    },
    {
        nome: "Isabelly",
        cargo: "Psicóloga",
        foto: "https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/psicologos%2Fnovas-fotos-2026%2FIsabelly%20-%20psico%CC%81loga.jpeg?alt=media&token=b5bf8c5a-78ed-4eda-91b5-1b2b9cbb2717",
        instagram: "https://www.instagram.com/psi.isabellyfrattini?stkn=MXFpamtwN2hlZWV0MA=="
    },
    {
        nome: "Daiane",
        cargo: "Fonoaudióloga",
        foto: "https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/psicologos%2Fnovas-fotos-2026%2FDaiane%20-%20fonoaudio%CC%81loga.jpeg?alt=media&token=4d2ec9ba-4343-4290-9a49-b062841884a3",
        instagram: "https://www.instagram.com/fonodaianecaro?stkn=MWtzbDYycDc1ZzZ5dw=="
    }
];

const Equipe = () => {
    const { data, permission, modules } = React.useContext(UserContext);

    return (
        <>
            <section className="breadcrumb-section">
                <div className="container">
                    <h1>Nossa Equipe</h1>
                    <div className="breadcrumb">
                        <a href="/home">Home</a>
                        <span className="fa fa-angle-double-right"></span>
                        <span className="current">Nossa Equipe</span>
                    </div>
                </div>
            </section>

            <div id="main">
                <div className="container">
                    <section id="primary" className="content-full-width">
                        <h2 className="dt-sc-hr-green-title">Equipe</h2>
                        {equipeMembros.map((membro, index) => (
                            <div
                                key={index}
                                className={`column dt-sc-one-fourth ${index % 4 === 0 ? "first" : ""}`}
                            >
                                <div className="dt-sc-team">
                                    <div className="image">
                                        <img
                                            className="item-mask"
                                            src="https://wedesignthemes.com/html/kidslife/images/mask.png"
                                            alt="mask"
                                        />
                                        <img src={membro.foto} alt={membro.nome} />
                                        <div className="dt-sc-image-overlay">
                                            <a
                                                href={membro.instagram}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="zoom"
                                            >
                                                <span className="fa fa-instagram"></span>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="team-details">
                                        <h4> {membro.nome} </h4>
                                        <h6> {membro.cargo} </h6>
                                    </div>
                                </div>
                            </div>
                        ))}

                        <div className="dt-sc-hr"></div>
                    </section>
                </div>
            </div>
        </>
    );
};

export default Equipe;


